export const userTypeGuardian = 'guardian';
export const userTypeUser = 'user';

export const userTypes = [userTypeGuardian, userTypeUser];
